import { useEffect, useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { ProofStrip } from "@/components/landing/ProofStrip";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { DemoModal } from "@/components/landing/DemoModal";
import { ConciergeHero } from "@/components/concierge/ConciergeHero";
import { Reveal } from "@/components/landing/Reveal";
import { Sparkles, Compass, Target } from "lucide-react";

const COLUMNS = [
  { icon: Sparkles, title: "Staging + Tours",
    body: "Empty photos become editorial staging in seconds; one phone spin becomes a 360° tour. All from the same chat.",
    to: "/features#cluster-a", testid: "concierge-col-staging" },
  { icon: Compass, title: "Comps + Pricing",
    body: "Ask for comps in your market. The concierge maps them, medians them, and tells you if you're priced to sell.",
    to: "/features#cluster-d", testid: "concierge-col-comps" },
  { icon: Target, title: "Campaigns + Leads",
    body: "One request builds Meta, Google, email, IG, LinkedIn, and print. Every scan becomes a scored lead in your inbox.",
    to: "/features#cluster-b", testid: "concierge-col-campaigns" },
];

export default function LandingPage() {
  const [demoOpen, setDemoOpen] = useState(false);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-bone" data-testid="landing-page">
      <Navbar />
      <main>
        <ConciergeHero onOpenDemo={() => setDemoOpen(true)} />
        <ProofStrip />

        <section id="post-hero" className="py-24 md:py-32 border-t border-ink/10" data-testid="concierge-three-col">
          <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
            <Reveal>
              <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">How the concierge does it</p>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-ink max-w-3xl">
                You talk. The concierge drives every system.
              </h2>
            </Reveal>
            <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/10 border border-ink/10">
              {COLUMNS.map((c, i) => (
                <Reveal key={c.title} delay={i * 0.08}>
                  <a href={c.to} className="block bg-bone p-8 md:p-10 h-full hover:bg-ink/[0.02] transition-colors group" data-testid={c.testid}>
                    <div className="w-11 h-11 border border-ink/15 flex items-center justify-center mb-6 group-hover:border-coral transition-colors">
                      <c.icon className="w-5 h-5 text-coral" />
                    </div>
                    <h3 className="font-serif text-3xl text-ink">{c.title}</h3>
                    <p className="mt-4 text-sm text-ink/65 leading-relaxed">{c.body}</p>
                    <p className="mt-6 text-xs text-coral border-b border-coral/40 pb-0.5 inline-block group-hover:text-ink group-hover:border-ink/40 transition-colors">Explore →</p>
                  </a>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        <FinalCTA />
      </main>
      <Footer />
      <DemoModal open={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
}
